export enum RiskIndicatorProfileMode {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
}
